import { Component } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { Token } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-reset-passwaord',
  templateUrl: './reset-passwaord.component.html',
  styleUrl: './reset-passwaord.component.scss'
})
export class ResetPasswaordComponent {

  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';

  constructor(private api:ApiServiceService , private toastr: ToastrService  ,private Loader:LoaderService){}



   // Method to handle password update
   updatePassword() {
    // Ensure new password and confirm password match
    if (this.newPassword !== this.confirmPassword) {
      this.toastr.error('New password and confirm password do not match');
      return;
    }

    const para ={ 
      currentPassword: this.currentPassword,
      newPassword: this.newPassword,
      confirmPassword: this.confirmPassword
      }  

    this.Loader.showLoader();
   this.api.changePassword(para).subscribe((res : any)=>{
this.Loader.hideLoader();
if (res ) {
  this.toastr.success(res.message ,'',{
    toastClass: 'ngx-toastr toast-custom'
  });
}else {
  this.Loader.hideLoader();

  this.toastr.error(res.message);
}
    })
  
 
}
}

